/*
   文件说明：
      该文件封装了axios，可以更方便地为请求添加token
*/
import axios from 'axios'
import requestConst from '@/utils/request-const'
import {
	MessageBox,
	Message
} from 'element-ui'
import router from "../router";
// let token = 'eyJhbGciOiJSUzI1325iJ9.eyJzdWIiInVzZXJJZCI6IjEiLCHdhHdjoiTXIuQUciLCJleHAiOjE1Nzc5NzU1MTl9.g5rXRfairB0kbOOsK8E26upPklagalh6otYqeHCPRElxfrG-NHSZI5kXJxNBOR1RA4fj5tI6MLwT09oH_ZmfRZbNBxKj_syEuE7YK32KwAymuRYL2jXG8gLMqHr8tMcuZN4TuFzO1-JF2su96s0fXOcKxvx5_Rg7tgGlbEVzdRI'
// export default function (data){
//    return axios({
//       ...data,
//       headers: { 'x-token': token }
//       // 模拟为每一个请求添加token
//    })
// }


// create an axios instance
const service = axios.create({
	// baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
	// withCredentials: true, // send cookies when cross-domain requests
	timeout: 30000 // request timeout

})

// request interceptor
service.interceptors.request.use(
	config => {
		let token = sessionStorage.getItem(requestConst.headers.sesstionCsrf)
		// do something before request is sent
		config.headers[requestConst.headers.csrf] = token
		if (process.env.NODE_ENV == 'development') {
			let greentoken = sessionStorage.getItem(requestConst.headers.greenChannel)
			// config.headers[requestConst.headers.greenChannel] = greentoken
			// config.headers[requestConst.headers.greenChannel] = "ItXNyOSS9OfceJNGQfkMJcdkn1tAt4TV3Qib1EGlaTorcgMtdYzeaA7OKg24ylrXNTxTHKFUmbhA7JveAhZfyuuEcMoP1SFN9bNFmVIzf0ENfdeep4ZU89kI14n5EUiAHICQVBdVik9RajTdXrXe3q0BP1RBng0EbiknE1AHT9w8b1ncFTJEDnyKQog0M76ejwkzwy7hrhq8zoQT5iHjFagMXROD6BLyIpXHlxYjmqPyMxNvDR55w6IMjv8ATRew8wNwjRw9wN8OHzoSD0XuiC5rd56IxTR.PZqdDZtg3XbFwwnOvFQ5YafuI1Kx4SE2wL1KTf4vqox"
			config.headers[requestConst.headers.greenChannel] = "p1rYnshCPLGDyymNnk9hlSEdd7LwWQCNzsMUvm2iAnJwsJFvgibbPxrJpm5etPBohW6BnYkcWIAk7zSg2AByRdXLFegMXU9axXrOwKQCl7mbQpiibCXZOxYwB3oPijqrknkBiIGdBiDw6H6rqFCyo7KxbMFeZ9jLl4rqhmEL4mjS3KviAqK6wh6gsO1vTJ0tXq9jOiyjpzh2UDfJxwV5UiUJ2lKbzJEKdg5BwEXl6oKxuE87xsXmXXI2RiKRdsEsupd0MGOka2KbPnqOdyRWfvtD4gXViLMfqlRMQQXyjHpIVRSx09722UaXkiYAOJp.7cB7UCjovJCZaPJ6aOtxDD"

		}

		config.headers['Accept'] = 'application/json; charset=utf-8'
		// 新逻辑 指定了 非post get之外的所有请求方式 全部进行请求方式转换处理
		// if (
		// 	config.method.toLocaleLowerCase() !== 'post' &&
		// 	config.method.toLocaleLowerCase() !== 'get'
		// ) {
		// 	config.headers['ORIGINAL-METHOD'] = config.method.toUpperCase()
		// 	config.method = 'POST'
		// 	console.log('请求方法 转换成功！')
		// }
		return config
	},
	error => {
		// do something with request error
		console.error(error) // for debug
		return Promise.reject(error)
	}
)
// response interceptor
service.interceptors.response.use(
	/**
	 * If you want to get http information such as headers or status
	 * Please return  response => response
	 */

	/**
	 * Determine the request status by custom code
	 * Here is just an example
	 * You can also judge the status by HTTP Status Code
	 */
	response => {
        // console.dir(response.data.status,1111111111111);
		const res = response.data
		//没有返回体
		if (!res) {
			console.debug('返回值错误')
			Message({
				message: '返回值错误',
				type: 'error',
				duration: 5 * 1000
			})
			return;
		}
		//200 状态时 如果返回的body的status!=0 也是失败
		// if (res.status != requestConst.body.SUCCESS) {
        //     console.log(111111);
		// 	let msg = res.msg ? res.msg : "出现错误";
		// 	//Message({
		// 	//message: msg,
		// 	//type: 'error',
		// 	//duration: 5 * 1000
		// 	//	})
		// 	return Promise.reject({
		// 		config: response.config,
		// 		isAxiosError: true,
		// 		request: response.request,
		// 		response: response
		// 	})
		// }
		return res
	},
	error => {
		//console.error('err' + error) // for debug
		//响应
		const res = error.response;
		//响应状态码
		const status = res.status;
		//响应体
		const body = res.data;
		//没有登录
		if (status === requestConst.http.UNAUTHORIZED) {
			console.error('没有登录');
			//跳到登录页
			return Promise.reject(error)
			router.push({
				name: 'login'
			})
		}
		//没有响应体
		if (!body) {
			console.log('返回值错误')
			Message({
				message: ' 返回值错误' + status,
				type: 'error',
				duration: 5 * 1000
			})
			return Promise.reject(error);
		}
		//响应体状态
		const bodystatus = body.status;
		if (bodystatus === requestConst.body.UNAUTHENTICATION) {
			console.log('没有登录');
			//跳到登录页
			router.push({
				name: 'login'
			})
		} else if (bodystatus === requestConst.body.CHART_REQUIRED) {

			console.log('还没选岗位');
			//跳到选岗位

		}
		//Message({
		//message: body.message,
		//type: 'error',
		//duration: 5 * 1000
		//})
		return Promise.reject(error)
	}
)
export default service
